export default __webpack_public_path__ + "static/media/naira.6a6965d6.webp";